import React from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import { ChillerCircuit } from '../../model';

interface PreviousLogCompressorMiniTableProps {
  circuit: ChillerCircuit;
}

const PreviousLogCompressorMiniTable: React.FC<PreviousLogCompressorMiniTableProps> = (props) => {
  let { circuit } = props;

  let compressorDetails = circuit?.compressors?.[0]?.compressor_details
    ?.map((row, index) => {
      return {
        display_name: row?.[0]?.display_name,
        compressor1Value: circuit?.compressors[0]?.compressor_details[index]?.[0]?.value,
        compressor2Value: circuit?.compressors[1]?.compressor_details[index]?.[0]?.value,
      };
    })
    .filter((detail) => detail.display_name !== 'Submit Date');

  return (
    <Table size="small">
      <TableHead>
        <TableRow style={{ background: '#A21C37' }}>
          <TableCell style={{ width: '250px', color: '#fff', fontWeight: 700 }}>
            Circuit {circuit?.index + 1} Compressors
          </TableCell>
          <TableCell style={{ color: '#fff', fontWeight: 700 }}>Comp 1</TableCell>
          <TableCell style={{ color: '#fff', fontWeight: 700 }}>Comp 2</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {compressorDetails?.map((item, index) => (
          <TableRow key={index}>
            <TableCell>{item?.display_name}</TableCell>
            <TableCell>{item?.compressor1Value}</TableCell>
            <TableCell>{item?.compressor2Value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PreviousLogCompressorMiniTable;
